<template>
    <div>
        <footer id="footer" class="sitecolor-content">
            <div v-if="patrocinadores?.length > 0" class="prefooter altcolor-content padding-vertical-content">
                <div class="container">
                    <div class="row align-items-center justify-content-center">
                        <div class="col-12 text-center">
                            <div class="h3 mt-0 text-uppercase">{{ $t('footer.patrocinadores') }}</div>
                            <carousel
                                :per-page="2"
                                :mouse-drag="false"
                                :loop="true"
                                :autoplay="true"
                                :autoplayTimeout="2000"
                                :autoplayHoverPause="true"
                                :scrollPerPage="true"
                                :perPageCustom="[[480, 3], [768, 4], [992, 6]]"
                                :centerMode="true"
                            >
                                <template v-for="(patrocinador, index) in patrocinadores">
                                    <slide v-bind:key="index">
                                        <a :href="patrocinador.url" target="_blank">
                                            <img :src="patrocinador.imagen_url" />
                                        </a>
                                    </slide>
                                </template>
                            </carousel>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row align-items-start">
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="h3">
                            {{ $t('footer.contacto') }}
                        </div>
                        <div v-html="footer.contacto">

                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-6 text-left text-lg-center">
                        <div class="h3">
                            {{ configuracion.title }}
                        </div><a href="https://www.compralaentrada.com/" class="logo"><img src="https://apiteatros.compralaentrada.com/images/logo_compralaentrada_white.png" width="50"/></a>

                        <ul class="menu d-flex justify-content-start justify-content-lg-center">
                            <li>
                                <router-link
                                    :to="{ name: 'legal' }"
                                    class="home-link  d-flex   text-center justify-content-center align-center align-items-center"
                                >
                                    <span>{{ $t('footer.legal') }}</span>
                                </router-link>
                            </li>

                            <li>
                                <router-link
                                    :to="{ name: 'privacidad' }"
                                    class="home-link  d-flex   text-center justify-content-center align-center align-items-center"
                                >
                                    <span>{{ $t('footer.privacidad') }}</span>
                                </router-link>
                            </li>

                            <li v-if="footer.condiciones_generales">
                                <router-link
                                    :to="{ name: 'condiciones_generales' }"
                                    class="home-link  d-flex   text-center justify-content-center align-center align-items-center"
                                >
                                    <span>{{ $t('footer.condiciones') }}</span>
                                </router-link>
                            </li>

                            <li>
                                <router-link
                                    :to="{ name: 'front.faqs.index' }"
                                    class="home-link  d-flex   text-center justify-content-center align-center align-items-center"
                                >
                                    <span>FAQ</span>
                                </router-link>
                            </li>
                        </ul>
                        <a class="home-link ml-1" href="https://www.compralaentrada.com/quienes-somos">{{ $t('footer.quienes_somos') }}</a>
                    </div>

                    <div class="col-12 col-md-6 col-lg-3 text-lg-right">
                        <div class="h3">
                            {{ $t('footer.siguenos') }}
                        </div>

                        <ul class="social-links">
                            <li v-if="footer.facebook">
                                <a :href="footer.facebook" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                                        <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" fill="currentColor"/>
                                    </svg>
                                </a>
                            </li>

                            <li v-if="footer.twitter">
                                <a :href="footer.twitter" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                                        <path fill="#fff" d="M8 2H1l8.26 11.015L1.45 22H4.1l6.388-7.349L16 22h7l-8.608-11.478L21.8 2h-2.65l-5.986 6.886zm9 18L5 4h2l12 16z"/>
                                    </svg>
                                </a>
                            </li>

                            <li class="mb-5 mb-md-0" v-if="footer.instagram">
                                <a :href="footer.instagram" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"/>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        data() {
            return {

            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            patrocinadores() {
                return this.$store.getters.getPatrocinadores;
            }
        },
        components: {
            Carousel,
            Slide
        }
    }
</script>

<style scoped>
    .social-links li {
        display: inline-block !important;
    }
</style>